module.exports = __webpack_public_path__ + "static/img/header_img.481159e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header_img.png
// module id = EB8I
// module chunks = 1